import { Component } from '@angular/core';

@Component({
  selector: 'bmat-starter-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'bmat-starter';
}
